import React, {Component} from 'react'
import { Link } from 'react-router-dom'
import imageResponsive from '../img/welcomeBg_responsive.jpg'
import imagePrincipal from '../img/welcomeBg.jpg'
/* import FilterBooking from '../componentes/FilterBooking' */
import Brands from '../componentes/Brands'
import Social from '../componentes/Social'

class Inicio extends Component{
    _isMounted = false;
    constructor(props) {
        super(props);
        this.state = {
            bgBanner: imagePrincipal,
            bgResponsive: imageResponsive
        };
    }
    updateDimensions() {
        if(window.innerWidth < 768) {
            if (this._isMounted) {
                this.setState({ 
                    bgBanner: imageResponsive
                })
                this.getImageLazy(this.state.bgResponsive)
            }
        } else {
            let bgBanner = imagePrincipal
            if (this._isMounted) {
                this.setState({ 
                    bgBanner: bgBanner
                })
                this.getImageLazy(this.state.bgBanner)
            }
        }
    }
    getImageLazy(url){
        let imgEl = document.getElementsByClassName('lazy');
        for (let i=0; i < imgEl.length; i++) {
            if( imgEl[i].getAttribute('data-src')) {
                imgEl[i].setAttribute('src', url);
                imgEl[i].removeAttribute('data-src');
            }
        }
    }
    componentDidMount() {
        this._isMounted = true;
        this.updateDimensions();
        window.addEventListener("resize", this.updateDimensions.bind(this));
    }
    componentWillUnmount() {
        this._isMounted = false;
        window.removeEventListener("resize", this.updateDimensions.bind(this));
    }
    render(){
        return (
            <main className="f f-ac">
                <article className="gwr">
                    <div className="text-mask">
                        <p className="parragraph--first"><span>Estadía relajante y segura</span></p> 
                        <p className="parragraph--second"><span>En</span></p><h1><span>Spring's Hotel</span></h1>
                        <p className="parragraph--third">Vivirás experiencias únicas en la naturaleza de nuestra selva peruana</p>
                    </div>
                    <div className="w-btn">
                        <Link to={'/dormitorios'} className="btn btn-primary" rel="preload">Ver Dormitorios</Link>
                        <Link to={'/contacto'}  className="btn btn-secondary" rel="preload">Contáctanos</Link>
                    </div>
                </article>
                <Brands />
                <figure className="iron-image__container">
                    <img data-src={this.state.bgBanner} className="lazy iron-image iron-image--fade-in" alt="Spring's Hotel" />
                </figure>
                {/* <FilterBooking /> */}
                <Social />
                <p className="develop">© 2019 Spring's Hotel - Todos los derechos reservados.</p>
            </main>
        )
    }
}

export default Inicio;